<template>
    <div class="animated fadeIn">
        <h3>Processer</h3>
        <b-card>
            <b-button-toolbar aria-label="Toolbar with button groups and input groups">
                <b-input-group size="sm">
                    <b-form-input ref="filter" class="text-left" placeholder="Filtrera..." v-model="flt"></b-form-input>
                </b-input-group>
                <b-button-group size="sm" class="mr-1">
                    <b-button @click="GetData()" variant="light" size="sm"><b-icon-arrow-repeat /></b-button>&nbsp;
                    <!-- <b-button @click="AddNew()" variant="light" size="sm">+</b-button> -->
                </b-button-group>
                <b-button-group size="sm" class="mr-1">
                    <b-button :variant="showActive ? 'primary' : 'light'" size="sm" title="Visa aktiva"
                        @click="showActive = !showActive"><b-icon-check-circle /></b-button>&nbsp;
                    <b-button :variant="showInactive ? 'primary' : 'light'" size="sm" title="Visa inaktiva"
                        @click="showInactive = !showInactive"><b-icon-circle /></b-button>&nbsp;
                </b-button-group>                
                <b-button-group size="sm" class="mr-1">
                    <b-form-select v-model="currInstance" :options="instances"></b-form-select>             
                </b-button-group>

            </b-button-toolbar>
            <b-card-body>
                <b-row v-if="lst">
                    <b-col>
                        <b-table hover small :items="GetItemsFiltered(flt)" :fields="fields" @row-clicked="showDetails">
                            <template #cell(Active)="row">
                                <b-icon-check-circle-fill variant="success" v-if="row.item.Active"></b-icon-check-circle-fill>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <b-modal v-model="detailsVisible" size="xl">            
            <inboxdetails v-if="currDetails" :inbox="currDetails" :instances="instances"></inboxdetails>
        </b-modal>
    </div>
</template>
<script>
import inboxdetails from './inboxdetails.vue';
import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'inboxlist',
    components: { inboxdetails},
    data() {
        return {
            lst: null,
            flt: null,
            fields: [
                { key: 'InboxName', label: 'Namn', sortable: true },
                { key: 'Type', label: 'Type', sortable: true },
                // { key: 'Katalog', label: 'Inbox', sortable: true },
                { key: 'Commands', label: 'Kommando', sortable: true },
                { key: 'Active', label: 'Aktiv', sortable: true },
                { key: 'ClientId', label: 'Instans', sortable: true },
            ],
            showActive: true,
            showInactive: false,//default
            instances: [],
            currInstance: null,
            currDetails: null,
            detailsVisible:false,
        }
    },
    created() {
        this.GetData();
    },
    methods: {
        GetData() {
            api.get('/api/Inbox').then(res => {
                this.lst = res.data;
                this.refreshInstances();
            });
        },
        GetItemsFiltered(flt) {
            let res = this.lst.filter(x => x.ClientId == this.currInstance
                && (this.showActive || !x.Active)
                && (this.showInactive || x.Active)
            );
            if (flt) {
                var s = flt.toLowerCase();
                res = res.filter(x =>
                    (JSON.stringify(x).toLowerCase().indexOf(s) >= 0)
                );
            }
            return res;
        },
        refreshInstances() {
            this.instances = [];
            if (this.lst) {
                let res = [];
                this.lst.forEach(x => {
                    if (x.ClientId) {
                        let r = res.find(it => it.clientId == x.ClientId);
                        if(r) 
                            r.cnt++;
                        else
                            res.push({ clientId: x.ClientId, cnt: 1 })
                    }
                });
                res = res.sort((a, b) => a.cnt < b.cnt);
                this.instances = res.map(x => x.clientId);
                if(this.instances.length>0)
                    this.currInstance=this.instances[0];
            }
        },
        showDetails(item) {
            let id = item.Id;
            api.get('/api/Inbox/'+id).then(res => {
                this.currDetails = res.data;
                this.detailsVisible =true;
            });
        }

    }
}

</script>

